import { Component, OnInit } from "@angular/core";
import { Empreiteira } from "src/app/models/empreiteira.model";
import { EmpreiteiraService } from "src/app/pages/cadastros/empreiteira/empreiteira.service";
import { PTService } from "src/app/pages/pt/pt.service";
import { OSService } from "src/app/services/os-service";
import { SpvService } from "src/app/services/spv.service";
import { APP_SETTINGS, SCAMP_API } from "src/environments/environment";

@Component({
  selector: "app-dots",
  templateUrl: "./dots.component.html",
  providers: [SpvService, PTService, OSService],
})
export class DotsComponent implements OnInit {
  public spvTotalAberto: number;
  public osTotalParaFechar: number;

  notificacaoSS: string = "";
  notificacaoOS: string = "";
  notificacaoVistoExecucao = "";
  notificacaoOSValidada = "";
  empreiteiras: Empreiteira[] = [];

  constructor(
    private spvService: SpvService,
    private osService: OSService,
    private empreiteiraService: EmpreiteiraService,
  ) {}

  ngOnInit() {
    this.updateNotificacoes();
  }

  updateNotificacoes() {
    this.ObterNotificacaoSS();

    this.empreiteiraService.getEmpreiteiras().subscribe((response) => {
      this.empreiteiras = response;

      if (this.empreiteiras.length == 1) {
        this.ObterNoticacaoOS(this.empreiteiras[0].id, 1);
        this.ObterNoticacaoVistoExecucao(this.empreiteiras[0].id, 2);
        this.ObterNoticacaoOSValidada(this.empreiteiras[0].id, 3) 

      } else {
        throw new Error(
          "Mais de uma empreiteira associada ao usuário. Funcionalidade não implementada.",
        );
      }
    });
  }

  ObterNotificacaoSS() {
    this.spvService.getSpvsAbertosQtd().subscribe((response) => {
      this.spvTotalAberto = response;

      if (!this.spvTotalAberto || this.spvTotalAberto == 0) {
        this.notificacaoSS = "Nenhuma SS aguardando <b>avaliação</b>";
      } else {
        if (this.spvTotalAberto == 1) {
          this.notificacaoSS =
            "Existe <b>1</b> SS que aguarda <b>avaliação</b>";
        } else {
          this.notificacaoSS = `Existem <b>${this.spvTotalAberto}</b> SSs que aguardam <b>avaliação</b>`;
        }
      }
    });
  }

  ObterNoticacaoOS(empreiteiraId: number, tipoAcaoOS: number) {
    this.osService
      .getOSsParaFecharQtd({
        EmpreiteiraId: empreiteiraId,
        TipoAcaoOS: tipoAcaoOS,
      })
      .subscribe((response) => {
        this.osTotalParaFechar = response;

        if (!this.osTotalParaFechar || this.osTotalParaFechar == 0) {
          this.notificacaoOS = "Nenhuma OS aguardando <b>fechamento</b>";
        } else {
          if (this.osTotalParaFechar == 1) {
            this.notificacaoOS =
              "Existe <b>1</b> OS que aguarda <b>fechamento</b>";
          } else {
            this.notificacaoOS = `Existem <b>${this.osTotalParaFechar}</b> OSs que aguardam <b>fechamento</b>`;
          }
        }
      });
  }

  ObterNoticacaoVistoExecucao(empreiteiraId: number, tipoAcaoOS: number) {
    this.osService
      .getOSsParaFecharQtd({
        EmpreiteiraId: empreiteiraId,
        TipoAcaoOS: tipoAcaoOS,
      })
      .subscribe((response) => {
        this.osTotalParaFechar = response;

        if (!this.osTotalParaFechar || this.osTotalParaFechar == 0) {
          this.notificacaoVistoExecucao =
            "Nenhuma OS aguardando <b>Visto de Execucao</b>";
        } else {
          if (this.osTotalParaFechar == 1) {
            this.notificacaoVistoExecucao =
              "Existe <b>1</b> OS que aguarda <b>Visto de Execucao</b>";
          } else {
            this.notificacaoVistoExecucao = `Existem <b>${this.osTotalParaFechar}</b> OSs que aguardam <b>Visto de Execucao</b>`;
          }
        }
      });
  }


  ObterNoticacaoOSValidada(empreiteiraId: number, tipoAcaoOS: number) {
    this.osService
      .getOSsParaFecharQtd({
        EmpreiteiraId: empreiteiraId,
        TipoAcaoOS: tipoAcaoOS,
      })
      .subscribe((response) => {
        this.osTotalParaFechar = response;

        if (!this.osTotalParaFechar || this.osTotalParaFechar == 0) {
          this.notificacaoOSValidada = "Nenhuma OS a ser <b>Validada</b>";
        } else {
          if (this.osTotalParaFechar == 1) {
            this.notificacaoOSValidada = "Existe <b>1</b> OS a ser <b>Validada</b>";
          } else {
            this.notificacaoOSValidada = `Existem <b>${this.osTotalParaFechar.toLocaleString('pt-BR')}</b> OSs a serem <b>Validadas</b>`;
          }
        }
      });
  }


  openManual() {
    window.open(
      `${SCAMP_API.pathUploadFiles}/${APP_SETTINGS.nomeManualSistema}`,
      "_blank",
      "width=760,height=610,resizable=yes,scrollbars=yes,status=1,left=30,top=50,location=no",
    );
  }
}
